var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('section',{staticClass:"text-center button-bar"},[(_vm.isRetryable)?_vm._t("default"):_vm._e(),(_vm.isValidRefUrl)?_c('button',{staticClass:"btn btn-default offset-left-1 offset-right-1",attrs:{"type":"button"},on:{"click":_vm.onRedirect}},[_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }